import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import BASE_URL from "./config/appconfig";

export default function ProtectedRoute({ children, role }) {
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    fetch(`${BASE_URL}/api/admin/verify`, { method: "GET" })
      .then((res) => {
        if (!res.ok) {
          setStatus("fail");
          return;
        }
        return res.json();
      })
      .then((data) => {
        if (!data) return;
        const serverRole = data.user?.roles?.name || data.user?.role;
        if (role && serverRole !== role) {
          setStatus("forbidden");
        } else {
          setStatus("ok");
        }
      })
      .catch(() => setStatus("fail"));
  }, [role]);

  if (status === "checking") return null;
  if (status === "fail" || status === "forbidden")
    return <Navigate to="/" replace />;

  return children;
}
